import * as yup from 'yup'
import { PersonDto } from './personDto'
import { VehicleRecallDto } from './vehicleRecallDto'

export class VehicleRecallNoteDto {
  // recallNoteGuid?: string = undefined
  note?: string = undefined
  createdBy?: PersonDto = undefined
  createdDateTime?: string = undefined
  recallCampaignId?: string = undefined
  vehicleRecall?: VehicleRecallDto = undefined
}

export const VehicleRecallNoteValidationSchema = yup.object({
  note: yup
    .string()
    .max(2000, 'Recall Notes cannot be more than 2000 characters')
    .required('Recall Note is required!')
    .nullable(),
  vehicleRecall: yup.object().nullable()
})
